/** 
 Copyright Highway9 Networks Inc. 
 */ 
import { MetricGraph } from "~/types/metricGraph";
import APIService from "./APIServices";

const metricsTemplate = new APIService<MetricGraph>("radios/metrics/templates");

export const metricsTemplateService = {
    getTemplates : metricsTemplate.getAll,
    createTemplate :  metricsTemplate.create,
    updateTemplate : metricsTemplate.update,
    deleteTemplate :  metricsTemplate.delete,
  }
